var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{attrs:{"to":_vm.to}},[_c('q-img',{staticClass:"logo",attrs:{"src":_vm.src ?? _vm.$options.logo,"contain":""}})],1),(_vm.showSwitcher)?_c('ActionsDropdown',{staticClass:"no-hover text-13-400",attrs:{"menu":_vm.actions,"color":"primary","dropdown-icon":"expand_more"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }